export default __webpack_public_path__ + "static/media/Transporte Coletivo.930e4963.svg";